(function () {
  'use strict';

  var STORAGE_KEY = 'coolify_compare';
  var RESET_KEY = 'coolify_compare_reset_v1';

  var MAX_PRODUCTS = 4;

  /*
   * ONE-TIME OLD COMPARE DATA RESET
   *
   * This removes old/incompatible compare products once.
   * It does NOT clear any other localStorage data.
   */
  try {
    if (!localStorage.getItem(RESET_KEY)) {
      localStorage.removeItem(STORAGE_KEY);
      localStorage.setItem(RESET_KEY, '1');
    }
  } catch (error) {
    // Ignore localStorage errors.
  }


  /*
   * GET COMPARE PRODUCTS
   */
  function getItems() {
    try {
      var raw = localStorage.getItem(STORAGE_KEY);

      var items = raw
        ? JSON.parse(raw)
        : [];

      if (!Array.isArray(items)) {
        return [];
      }

      var unique = [];

      items.forEach(function (item) {
        if (
          typeof item === 'string' &&
          item.trim() !== '' &&
          unique.indexOf(item) === -1
        ) {
          unique.push(item);
        }
      });

      return unique.slice(0, MAX_PRODUCTS);

    } catch (error) {
      return [];
    }
  }


  /*
   * SAVE COMPARE PRODUCTS
   */
  function saveItems(items) {
    var unique = [];

    (Array.isArray(items) ? items : []).forEach(
      function (item) {
        if (
          typeof item === 'string' &&
          item.trim() !== '' &&
          unique.indexOf(item) === -1
        ) {
          unique.push(item);
        }
      }
    );

    unique = unique.slice(0, MAX_PRODUCTS);

    try {
      localStorage.setItem(
        STORAGE_KEY,
        JSON.stringify(unique)
      );
    } catch (error) {
      return;
    }

    document.dispatchEvent(
      new CustomEvent(
        'coolify:compare:updated',
        {
          detail: {
            items: unique
          }
        }
      )
    );
  }


  /*
   * UPDATE ALL COMPARE BUTTONS / COUNTERS
   */
  function updateCompareUI() {
    var items = getItems();


    /*
     * Compare counter
     */
    document
      .querySelectorAll(
        '[data-compare-count]'
      )
      .forEach(function (element) {

        element.textContent =
          items.length;

        element.classList.toggle(
          'is-empty',
          items.length === 0
        );
      });


    /*
     * Compare product buttons
     */
    document
      .querySelectorAll(
        '[data-compare-product]'
      )
      .forEach(function (button) {

        var handle =
          button.getAttribute(
            'data-compare-product'
          );

        if (!handle) {
          return;
        }

        var added =
          items.indexOf(handle) !== -1;


        button.classList.toggle(
          'is-added',
          added
        );

        button.classList.toggle(
          'is-active',
          added
        );


        button.setAttribute(
          'aria-pressed',
          added
            ? 'true'
            : 'false'
        );


        var text =
          button.querySelector(
            '[data-compare-button-text]'
          );

        if (text) {
          text.textContent =
            added
              ? 'Added to Compare'
              : 'Compare';
        }
      });
  }


  /*
   * ADD PRODUCT
   */
  function addProduct(handle) {

    if (!handle) {
      return;
    }

    var items = getItems();


    /*
     * Already added
     */
    if (
      items.indexOf(handle) !== -1
    ) {
      updateCompareUI();
      return;
    }


    /*
     * Maximum 4 products
     */
    if (
      items.length >= MAX_PRODUCTS
    ) {
      alert(
        'You can compare up to 4 products.'
      );

      return;
    }


    items.push(handle);

    saveItems(items);

    updateCompareUI();
  }


  /*
   * REMOVE PRODUCT
   */
  function removeProduct(handle) {

    var items =
      getItems().filter(
        function (item) {
          return item !== handle;
        }
      );

    saveItems(items);

    updateCompareUI();
  }


  /*
   * TOGGLE PRODUCT
   */
  function toggleProduct(handle) {

    if (!handle) {
      return;
    }

    var items = getItems();

    if (
      items.indexOf(handle) !== -1
    ) {

      removeProduct(handle);

    } else {

      addProduct(handle);

    }
  }


  /*
   * COMPARE BUTTON CLICK
   *
   * IMPORTANT:
   *
   * There is NO
   * data-compareHandled check here.
   *
   * This prevents an old compare script
   * from blocking the current compare button.
   */
  document.addEventListener(
    'click',
    function (event) {

      var target =
        event.target;

      if (!target) {
        return;
      }


      var button =
        target.closest(
          '[data-compare-product]'
        );


      if (!button) {
        return;
      }


      var handle =
        button.getAttribute(
          'data-compare-product'
        );


      if (!handle) {
        return;
      }


      event.preventDefault();

      event.stopPropagation();


      toggleProduct(handle);

    },
    false
  );


  /*
   * COMPARE UPDATED EVENT
   */
  document.addEventListener(
    'coolify:compare:updated',
    function () {

      updateCompareUI();

    }
  );


  /*
   * OTHER BROWSER TABS
   */
  window.addEventListener(
    'storage',
    function (event) {

      if (
        event.key === STORAGE_KEY
      ) {

        updateCompareUI();

      }

    }
  );


  /*
   * PUBLIC API
   */
  window.CoolifyCompare = {

    get: getItems,

    add: addProduct,

    remove: removeProduct,

    toggle: toggleProduct,

    clear: function () {

      saveItems([]);

      updateCompareUI();

    },

    max: MAX_PRODUCTS

  };


  /*
   * INITIAL UI
   */
  function initializeCompare() {

    updateCompareUI();

  }


  if (
    document.readyState ===
    'loading'
  ) {

    document.addEventListener(
      'DOMContentLoaded',
      initializeCompare
    );

  } else {

    initializeCompare();

  }

})();